export default __webpack_public_path__ + "static/media/book-icon.1ca4494e.svg";